import { useObserver } from 'mobx-react-lite';
import React from 'react';
import { useScreen } from '../../stores/ScreenStore';
import ViewStateContainer from '../Core/ViewStateContainer/ViewStateContainer';
import Screen from './Screen';

ScreenPage.propTypes = {};

export default function ScreenPage() {
  const screenStore = useScreen();

  return useObserver(() => (
    <ViewStateContainer
      state={screenStore.viewState}
      onReload={() => screenStore.reload()}
    >
      <Screen screen={screenStore.screen} orders={screenStore.orders} />
    </ViewStateContainer>
  ));
}
